import { render, staticRenderFns } from "./ClassifiedManagement.vue?vue&type=template&id=2d00665b&"
import script from "./ClassifiedManagement.vue?vue&type=script&lang=js&"
export * from "./ClassifiedManagement.vue?vue&type=script&lang=js&"
import style0 from "./ClassifiedManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports